module.exports = __webpack_public_path__ + "img/1.ad7bf1d6.png";